export default "__VITE_ASSET__R8Y74f74__"